export default "__VITE_ASSET__Dt5OKcT8__"